/**
 * 🚧 GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by scripts/generateMenuIds.ts
 */
export const MenuIds = {
    MANAJEMEN: {
        "id": "01",
        APLIKASI: {
            "id": "0101",
            LEMBAGA: {
                "id": "010101"
            },
            AKUN: {
                "id": "010102"
            },
            CABANG: {
                "id": "010103"
            },
            ROLE: {
                "id": "010105"
            },
            MENU: {
                "id": "010106"
            },
            AKSES: {
                "id": "010107"
            },
            USER: {
                "id": "010108"
            },
            KONSOLIDASI: {
                "id": "010109"
            },
            COUNTER: {
                "id": "010110"
            },
            DEVICE: {
                "id": "010111"
            },
            SISTEM: {
                "id": "010112"
            },
            DAFTAR_LEMBAGA: {
                "id": "010113"
            },
            DAFTAR_DOMAIN: {
                "id": "010114"
            },
            PAKET_LANGGANAN: {
                "id": "010115"
            }
        },
        TRANSAKSI: {
            "id": "0102",
            TEMPLATE: {
                "id": "010201"
            },
            HARI_LIBUR: {
                "id": "010202"
            },
            KELOMPOK: {
                "id": "010203"
            },
            CLOSING: {
                "id": "010204"
            },
            AREA: {
                "id": "010205"
            }
        },
        UTILITAS: {
            "id": "0103",
            LOG_TRANSAKSI: {
                "id": "010301"
            },
            MIGRASI_TOOLS: {
                "id": "010302"
            },
            KOREKSI_TUTUP_HARI: {
                "id": "010303"
            },
            KOREKSI_TUTUP_BULAN: {
                "id": "010304"
            },
            KOREKSI_TUTUP_TAHUN: {
                "id": "010305"
            },
            KOREKSI_OTODEBET: {
                "id": "010306"
            },
            CHECK_BALANCE: {
                "id": "010307"
            },
            PERBAIKAN_DATA_MASTER: {
                "id": "010308"
            }
        }
    },
    MASTER_DATA: {
        "id": "02",
        MAIN: {
            "id": "0201",
            KODE_NEGARA: {
                "id": "020101"
            },
            KODE_KOTA: {
                "id": "020102"
            },
            KODE_POS: {
                "id": "020103"
            },
            KODE_GELAR: {
                "id": "020104"
            },
            KODE_BANK: {
                "id": "020105"
            },
            KODE_PEKERJAAN: {
                "id": "020106"
            },
            KODE_ASURANSI: {
                "id": "020107"
            },
            KODE_NOMINASI: {
                "id": "020108"
            },
            KODE_VALAS: {
                "id": "020109"
            },
            KODE_PEMASOK: {
                "id": "020110"
            }
        },
        FINANCE: {
            "id": "0202",
            FASILITAS_SLIK: {
                "id": "020201"
            },
            GOV_KREDIT_SLIK: {
                "id": "020202"
            },
            GOLONGAN_DEBITUR: {
                "id": "020203"
            },
            GOLONGAN_KREDITUR: {
                "id": "020204"
            },
            GOLONGAN_PENJAMIN: {
                "id": "020205"
            },
            GROUP_DEBITUR: {
                "id": "020206"
            },
            HUBUNGAN_BANK: {
                "id": "020207"
            },
            HUBUNGAN_LJK_SLIK: {
                "id": "020208"
            },
            IKATAN_HUKUM: {
                "id": "020209"
            },
            IKATAN_HUKUM_SLIK: {
                "id": "020210"
            },
            JENIS_AGUNAN: {
                "id": "020211"
            },
            JENIS_AGUNAN_SLIK: {
                "id": "020212"
            },
            JENIS_AKAD: {
                "id": "020213"
            },
            JENIS_DOKUMEN: {
                "id": "020214"
            },
            JENIS_KREDIT_SLIK: {
                "id": "020215"
            },
            JENIS_PENGGUNAAN: {
                "id": "020216"
            },
            JENIS_PENGGUNAAN_SLIK: {
                "id": "020217"
            },
            KATEGORI_DEBITUR_SLIK: {
                "id": "020218"
            },
            KUR_SANDI_BI: {
                "id": "020219"
            },
            LEMBAGA_RATING: {
                "id": "020220"
            },
            LOKASI: {
                "id": "020221"
            },
            ORIENTASI_PENGGUNAAN_SLIK: {
                "id": "020222"
            },
            P2PL: {
                "id": "020223"
            },
            PEMILIK: {
                "id": "020224"
            },
            PIHAK_KETIGA_SLIK: {
                "id": "020225"
            },
            SEKTOR_EKONOMI: {
                "id": "020226"
            },
            SEKTOR_EKONOMI_OBOX: {
                "id": "020227"
            },
            SEKTOR_EKONOMI_SLIK: {
                "id": "020228"
            },
            SIFAT_PEMBIAYAAN: {
                "id": "020229"
            },
            SIFAT_KREDIT_SLIK: {
                "id": "020230"
            },
            SUMBER_DANA: {
                "id": "020231"
            },
            TKS_ATMR: {
                "id": "020232"
            }
        },
        EDU: {
            "id": "0203",
            PENDIDIKAN: {
                "id": "020301"
            },
            JABATAN: {
                "id": "020302"
            },
            PROFESI: {
                "id": "020303"
            },
            PENILAIAN: {
                "id": "020304"
            },
            PEMBELAJARAN: {
                "id": "020305"
            },
            KELAS: {
                "id": "020306"
            },
            PERGURUAN_TINGGI: {
                "id": "020307"
            },
            KALENDER_AKADEMIK: {
                "id": "020308"
            },
            JAM_BELAJAR: {
                "id": "020309"
            },
            KATALOG_LOMBA: {
                "id": "020310"
            }
        }
    },
    CUSTOMER_DATA: {
        "id": "03",
        MAIN: {
            "id": "0301",
            NASABAH: {
                "id": "030101"
            },
            LAYANAN_NASABAH_DAN_SIMULASI: {
                "id": "030102",
                SIMULASI_PEMBIAYAAN: {
                    "id": "03010201"
                },
                TABUNGAN_RENCANA: {
                    "id": "03010202"
                },
                LAYANAN_NASABAH: {
                    "id": "03010203"
                }
            },
            DTOT: {
                "id": "030103"
            },
            NASABAH_RELASI: {
                "id": "030104"
            }
        },
        SETTING: {
            "id": "0302",
            SOAL_APUPPT: {
                "id": "030201"
            }
        },
        LAPORAN: {
            "id": "0303",
            LAPORAN_NASABAH: {
                "id": "030301"
            },
            DAFTAR_RENCANA_PENCAIRAN_CABANG: {
                "id": "030302"
            },
            DATA_KTP_JATUH_TEMPO: {
                "id": "030303"
            },
            DAFTAR_NASABAH_ULANG_TAHUN: {
                "id": "030304"
            },
            DAFTAR_AKTIVITAS_NASABAH: {
                "id": "030305"
            },
            DAFTAR_NASABAH_APUPPT: {
                "id": "030306"
            }
        }
    },
    SUPPLIER_DATA: {
        "id": "04",
        DATA_UTAMA: {
            "id": "0401",
            DATA_SUPPLIER: {
                "id": "040101"
            }
        },
        SETTING: {
            "id": "0402"
        },
        LAPORAN: {
            "id": "0403"
        }
    },
    FINANCE: {
        "id": "05",
        LOAN: {
            "id": "0501",
            MAIN: {
                "id": "050101",
                DATA_REKENING: {
                    "id": "05010101"
                }
            },
            ADMIN: {
                "id": "050102",
                BI_SUKU_BUNGA: {
                    "id": "05010201"
                },
                KOREKSI_DATA_PEMBIAYAAN: {
                    "id": "05010202"
                },
                PERPANJANGAN_PINJAMAN: {
                    "id": "05010203"
                },
                RESTRUKTUR_PINJAMAN: {
                    "id": "05010204"
                },
                HAPUS_BUKU: {
                    "id": "05010205"
                },
                BATCH_TAGIHAN: {
                    "id": "05010206"
                },
                PENGAMBILAN_AGUNAN: {
                    "id": "05010207"
                },
                PPAP_WD: {
                    "id": "05010208"
                },
                PERUBAHAN_PLAFOND: {
                    "id": "05010209"
                },
                SURAT_PERINGATAN: {
                    "id": "05010210"
                },
                MONITORING: {
                    "id": "05010211"
                },
                HAPUS_TAGIH: {
                    "id": "05010212"
                },
                RIWAYAT_KOLEKTIBILITAS: {
                    "id": "05010213"
                },
                TARGET_PEMBIAYAAN: {
                    "id": "05010214"
                },
                CKPN: {
                    "id": "05010215"
                },
                CKPN_KOLEKTIF: {
                    "id": "05010216"
                },
                HAPUS_TRANSAKSI: {
                    "id": "05010217"
                },
                HAPUS_KREACCRUAL: {
                    "id": "05010218"
                },
                HAPUS_KREPPAP: {
                    "id": "05010219"
                },
                HAPUS_AYDA: {
                    "id": "05010220"
                }
            },
            SETTING: {
                "id": "050103",
                PRODUK_PEMBIAYAAN: {
                    "id": "05010301"
                },
                KODE_TRANSAKSI_PEMBIAYAAN: {
                    "id": "05010302"
                }
            },
            COLATERAL: {
                "id": "050104"
            },
            REPORT: {
                "id": "050105",
                NOMINATIF_PEMBIAYAAN: {
                    "id": "05010501"
                },
                TRANSAKSI_PEMBIAYAAN: {
                    "id": "05010502"
                },
                MUTASI_PEMBIAYAAN: {
                    "id": "05010503"
                },
                REKENING_KORAN_PEMBIAYAAN: {
                    "id": "05010504"
                },
                TAGIHAN: {
                    "id": "05010505"
                },
                ACCRUAL: {
                    "id": "05010506"
                },
                PPAP: {
                    "id": "05010507"
                },
                PERFORMANCE_COLLECTION_PEMBIAYAAN: {
                    "id": "05010508"
                },
                DAFTAR_PEMBIAYAAN_LUNAS: {
                    "id": "05010509"
                },
                LAPORAN_PENGAMBILAN_AGUNAN: {
                    "id": "05010510"
                },
                LAPORAN_NOMINATIF_PROVISI: {
                    "id": "05010511"
                },
                REKENING_KORAN_PRK: {
                    "id": "05010512"
                },
                PEMBIAYAAN_BARU: {
                    "id": "05010513"
                },
                AMORTISASI_ADMIN: {
                    "id": "05010514"
                },
                AMORTISASI_BIAYA: {
                    "id": "05010515"
                },
                PROYEKSI_ACCRUAL_BUNGA_PEMBIAYAAN: {
                    "id": "05010516"
                },
                PROYEKSI_PPAP_PEMBIAYAAN: {
                    "id": "05010517"
                },
                NPF_KOMPARATIF: {
                    "id": "05010518"
                },
                NOMINATIF_HAPUS_BUKU: {
                    "id": "05010519"
                },
                NOMINATIF_AYDA: {
                    "id": "05010520"
                },
                NOMINATIF_BUNGA_RESTRUKTUR: {
                    "id": "05010521"
                },
                NOMINATIF_CHANNELING: {
                    "id": "05010522"
                },
                NOMINATIF_DENDA_RESTRUKTUR: {
                    "id": "05010523"
                }
            }
        },
        SAVING: {
            "id": "0502",
            DATA_UTAMA: {
                "id": "050201",
                DATA_REKENING: {
                    "id": "05020101"
                }
            },
            ADMINISTRASI: {
                "id": "050202",
                HAPUS_TRANSAKSI: {
                    "id": "05020201"
                },
                KOREKSI_BUNGA_DAN_PAJAK_TABUNGAN: {
                    "id": "05020202"
                },
                BLOKIR_UNBLOKIR_TABUNGAN: {
                    "id": "05020203"
                },
                HAPUS_TABACCRUAL: {
                    "id": "05020204"
                },
                HAPUS_TABPPAP: {
                    "id": "05020205"
                },
                HAPUS_TABAMORTISASI: {
                    "id": "05020206"
                }
            },
            SETTING: {
                "id": "050203",
                PRODUK_TABUNGAN: {
                    "id": "05020301"
                },
                KODE_TRANSAKSI_TABUNGAN: {
                    "id": "05020302"
                },
                KODE_BUKU_TABUNGAN: {
                    "id": "05020303"
                }
            },
            LAPORAN: {
                "id": "050204",
                NOMINATIF_TABUNGAN: {
                    "id": "05020401"
                },
                TRANSAKSI_TABUNGAN: {
                    "id": "05020402"
                },
                REKENING_KORAN_TABUNGAN: {
                    "id": "05020403"
                },
                TABUNGAN_BARU: {
                    "id": "05020404"
                },
                TABUNGAN_TUTUP: {
                    "id": "05020405"
                },
                TAGIHAN_TABUNGAN_RENCANA: {
                    "id": "05020406"
                },
                BUNGA_PAJAK_ADMIN: {
                    "id": "05020407"
                },
                MUTASI_TRANSAKSI: {
                    "id": "05020408"
                },
                ACCRUAL: {
                    "id": "05020409"
                },
                GAGAL_OTODEBET_TABUNGAN_RENCANA: {
                    "id": "05020410"
                },
                TABUNGAN_RENCANA_JATUH_TEMPO: {
                    "id": "05020411"
                },
                PPAP_TABUNGAN_ABA: {
                    "id": "05020412"
                },
                TABUNGAN_BLOKIR: {
                    "id": "05020413"
                },
                AMORTISASI_BIAYA: {
                    "id": "05020414"
                },
                TAGIHAN_TABUNGAN_WAJIB: {
                    "id": "05020415"
                }
            }
        },
        DEPOSITO: {
            "id": "0503",
            DATA_UTAMA: {
                "id": "050301",
                DATA_REKENING: {
                    "id": "05030101"
                }
            },
            ADMINISTRASI: {
                "id": "050302",
                KOREKSI_BUNGA_PAJAK_DEPOSITO: {
                    "id": "05030201"
                },
                BLOKIR_DEPOSITO: {
                    "id": "05030202"
                },
                PERPANJANGAN_DEPOSITO: {
                    "id": "05030203"
                },
                HAPUS_TRANSAKSI: {
                    "id": "05030204"
                },
                HAPUS_DEPACCRUAL: {
                    "id": "05030205"
                },
                HAPUS_DEPPPAP: {
                    "id": "05030206"
                },
                HAPUS_DEPAMORTISASI: {
                    "id": "05030207"
                }
            },
            SETTING: {
                "id": "050303",
                PRODUK_DEPOSITO: {
                    "id": "05030301"
                },
                KODE_TRANSAKSI_DEPOSITO: {
                    "id": "05030302"
                },
                KOMISI_DEPOSITO: {
                    "id": "05030303"
                }
            },
            LAPORAN: {
                "id": "050304",
                NOMINATIF_DEPOSITO: {
                    "id": "05030401"
                },
                TRANSAKSI_DEPOSITO: {
                    "id": "05030402"
                },
                REKENING_KORAN_DEPOSITO: {
                    "id": "05030403"
                },
                DEPOSITO_BARU: {
                    "id": "05030404"
                },
                DEPOSITO_TUTUP: {
                    "id": "05030405"
                },
                ACCRUAL: {
                    "id": "05030406"
                },
                BUNGA_PAJAK: {
                    "id": "05030407"
                },
                JADWAL_BAYAR_BUNGA_PAJAK: {
                    "id": "05030408"
                },
                JATUH_TEMPO_DEPOSITO: {
                    "id": "05030409"
                },
                PERPANJANGAN_DEPOSITO: {
                    "id": "05030410"
                },
                PPAP_DEPOSITO_ABA: {
                    "id": "05030411"
                },
                DEPOSITO_BLOKIR: {
                    "id": "05030412"
                },
                AMORTISASI_BIAYA: {
                    "id": "05030413"
                },
                FEE_DEPOSITO: {
                    "id": "05030414"
                }
            }
        },
        TELLER: {
            "id": "0504",
            TRANSAKSI: {
                "id": "050401",
                LOAN: {
                    "id": "05040101",
                    PERSEORANGAN: {
                        "id": "0504010101"
                    },
                    KOLEKTIF: {
                        "id": "0504010102"
                    }
                },
                SAVING: {
                    "id": "05040102",
                    PERSEORANGAN: {
                        "id": "0504010201"
                    },
                    KOLEKTIF: {
                        "id": "0504010202"
                    }
                },
                DEPOSITO: {
                    "id": "05040103",
                    PERSEORANGAN: {
                        "id": "0504010301"
                    }
                },
                KAS_UMUM: {
                    "id": "05040104"
                }
            },
            RAK: {
                "id": "050402",
                LOAN: {
                    "id": "05040201",
                    PERSEORANGAN: {
                        "id": "0504020101"
                    },
                    KOLEKTIF: {
                        "id": "0504020102"
                    }
                },
                SAVING: {
                    "id": "05040202",
                    PERSEORANGAN: {
                        "id": "0504020201"
                    },
                    KOLEKTIF: {
                        "id": "0504020202"
                    }
                },
                DEPOSITO: {
                    "id": "05040203",
                    PERSEORANGAN: {
                        "id": "0504020301"
                    }
                },
                KAS_UMUM: {
                    "id": "05040204"
                }
            },
            ADMINISTRASI: {
                "id": "050403",
                HAPUS_TRANSAKSI_KAS: {
                    "id": "05040301"
                },
                APPROVAL_TELLER: {
                    "id": "05040302"
                }
            },
            SETTING: {
                "id": "050404",
                KODE_DNOMINASI: {
                    "id": "05040401"
                }
            },
            LAPORAN: {
                "id": "050405",
                POSISI_KAS: {
                    "id": "05040501"
                },
                BUKU_TABUNGAN: {
                    "id": "05040502"
                },
                COVER_BUKU_TABUNGAN: {
                    "id": "05040503"
                }
            }
        }
    },
    AKUNTANSI: {
        "id": "06",
        PEMBUKUAN: {
            "id": "0601",
            DATA_UTAMA: {
                "id": "060101",
                JURNAL_UMUM: {
                    "id": "06010101"
                },
                JURNAL_UMUM_RENCANA: {
                    "id": "06010102"
                }
            },
            SETTING: {
                "id": "060102",
                POSTING: {
                    "id": "06010201"
                },
                UN_POSTING_LIST: {
                    "id": "06010202"
                },
                TAKSIRAN_PAJAK: {
                    "id": "06010203"
                },
                PINDAH_AKUN: {
                    "id": "06010204"
                },
                SETTING: {
                    "id": "06010205"
                },
                PERKIRAAN: {
                    "id": "06010206"
                },
                KONFIGURASI_GL: {
                    "id": "06010207"
                }
            },
            LAPORAN: {
                "id": "060103",
                NERACA_LABA_RUGI: {
                    "id": "06010301"
                },
                TRIAL_BALLANCE: {
                    "id": "06010302"
                },
                JURNAL_LIST: {
                    "id": "06010303"
                },
                BUKU_BESAR: {
                    "id": "06010304"
                },
                DANA_PIHAK_KE_TIGA: {
                    "id": "06010305"
                },
                DISTRIBUSI_BAGI_HASIL: {
                    "id": "06010306"
                },
                CASH_FLOW: {
                    "id": "06010307"
                },
                NERACA_LABA_RUGI_KOMPARATIF: {
                    "id": "06010308"
                },
                BUNGA_PAJAK: {
                    "id": "06010309"
                },
                NERACA_LABA_RUGI_RENCANA: {
                    "id": "06010310"
                },
                TRIAL_BALLANCE_RENCANA: {
                    "id": "06010311"
                },
                JURNAL_LIST_RENCANA: {
                    "id": "06010312"
                }
            }
        },
        INVENTARIS: {
            "id": "0602",
            DATA_UTAMA: {
                "id": "060201",
                DATA_REKENING: {
                    "id": "06020101"
                }
            },
            SETTING: {
                "id": "060202",
                PRODUK_INVENTARIS: {
                    "id": "06020201"
                }
            },
            LAPORAN: {
                "id": "060203"
            }
        },
        RRA: {
            "id": "0603",
            DATA_UTAMA: {
                "id": "060301",
                DATA_REKENING: {
                    "id": "06030101"
                }
            },
            SETTING: {
                "id": "060302",
                PRODUK_RRA: {
                    "id": "06030201"
                }
            },
            LAPORAN: {
                "id": "060303"
            }
        },
        RRP: {
            "id": "0604",
            DATA_UTAMA: {
                "id": "060401",
                DATA_REKENING: {
                    "id": "06040101"
                }
            },
            SETTING: {
                "id": "060402",
                PRODUK_RRP: {
                    "id": "06040201"
                }
            },
            LAPORAN: {
                "id": "060403"
            }
        }
    },
    CLOSING_DATA: {
        "id": "07",
        TUTUP_HARI: {
            "id": "0701"
        },
        TUTUP_BULAN: {
            "id": "0702"
        },
        TUTUP_TAHUN: {
            "id": "0703"
        }
    },
    EDU: {
        "id": "08",
        SCHOOL_MANAGEMENT_SYSTEM: {
            "id": "0801",
            JURNAL: {
                "id": "080101",
                KEGIATAN_BELAJAR_MENGAJAR: {
                    "id": "08010101"
                },
                PENGAWASAN: {
                    "id": "08010102"
                },
                TUGAS_DAN_PENILAIAN: {
                    "id": "08010103"
                },
                MUTABA_AH_HAFALAN: {
                    "id": "08010104"
                },
                KONSELING: {
                    "id": "08010105"
                },
                PRESTASI_LOMBA: {
                    "id": "08010106"
                },
                TRY_OUT_UTBK: {
                    "id": "08010107"
                }
            },
            PENGATURAN: {
                "id": "080102",
                DATA_ROMBEL: {
                    "id": "08010201"
                },
                MODUL_AJAR: {
                    "id": "08010202"
                },
                TARGET_PTN: {
                    "id": "08010203"
                },
                DATA_JADWAL: {
                    "id": "08010204"
                }
            },
            LAPORAN: {
                "id": "080103",
                PRESENSI: {
                    "id": "08010301"
                },
                JURNAL_AKTIVITAS: {
                    "id": "08010302"
                },
                JURNAL_PENGAWASAN: {
                    "id": "08010303"
                },
                JURNAL_TUGAS_DAN_NILAI: {
                    "id": "08010304"
                },
                JURNAL_MUTABAAH: {
                    "id": "08010305"
                },
                JURNAL_KONSELING: {
                    "id": "08010306"
                },
                RAPOR_SISWA: {
                    "id": "08010307"
                },
                TRY_OUT_UTBK: {
                    "id": "08010308"
                }
            }
        },
        LEARNING_MANAGEMENT_SYSTEM: {
            "id": "0802"
        },
        AKADEMI: {
            "id": "0802",
            KATALOG_KURIKULUM: {
                "id": "080201",
                KATEGORI_KURSUS: {
                    "id": "08020101"
                },
                DAFTAR_KURSUS: {
                    "id": "08020102"
                },
                KURIKULUM_SILABUS: {
                    "id": "08020103"
                }
            },
            REVIEW_MENTORING: {
                "id": "080202",
                REVIEW_PROYEK: {
                    "id": "08020201"
                },
                FORUM_DISKUSI: {
                    "id": "08020202"
                }
            },
            KREDENSIAL_LAPORAN: {
                "id": "080203",
                LOG_SERTIFIKAT: {
                    "id": "08020301"
                },
                REKAP_KELULUSAN: {
                    "id": "08020302"
                },
                PROGRES_SISWA: {
                    "id": "08020303"
                }
            }
        },
        ASSESSMENT: {
            "id": "0803",
            UJIAN: {
                "id": "080301",
                SESI_UJIAN: {
                    "id": "08030101"
                },
                MONITOR_UJIAN: {
                    "id": "08030102"
                },
                PENILAIAN_ESSAY: {
                    "id": "08030103"
                }
            },
            PENGATURAN: {
                "id": "080302",
                JENIS_UJIAN: {
                    "id": "08030201"
                },
                BANK_SOAL: {
                    "id": "08030202"
                },
                PAKET_UJIAN: {
                    "id": "08030203"
                }
            },
            LAPORAN: {
                "id": "080303",
                REKAP_NILAI: {
                    "id": "08030301"
                },
                ANALISIS_SOAL: {
                    "id": "08030302"
                }
            }
        }
    }
};
